<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <Button
                    v-if="$can('update')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading || isDisabled"
                    @click="onClickSetting"
                >
                    批量设置
                </Button>
            </template>
        </table-tool-bar>
        <!-- 列表-->
        <tree-table
            ref="mt"
            :columns="columns"
            :data="treeList"
            :loading="loading"
            :height="mtHeight"
            showCheckbox
            showExpandLevel
            multiple
            @on-check-change="checkChange"
            @on-toggle-expand="toggleExpand"
        >
            <template v-slot:action="{ row }">
                <Button
                    v-if="row.level === 4"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickSetting(row)"
                >
                    设置
                </Button>
            </template>
        </tree-table>

        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showMeterForm"
            title="水电设置"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <c-meter-form v-if="modal.showMeterForm" :houseIds="houseIds" />
        </smart-modal>
    </div>
</template>

<script>
import { smartmeterList } from '@/api/setting-meter'
import { currency } from '_u/helper.js'
import CMeterForm from './c-meter-form'

export default {
    name: 'c-meter-list',
    data() {
        return {
            loading: false,
            mtHeight: 360,
            houseIds: '',
            modal: {
                showMeterForm: false,
            },
            dict: {},
            treeList: [],
            nodeList: [],
            foldMap: [], //{id: "", expand: true}
        }
    },
    components: {
        CMeterForm,
    },
    computed: {
        columns() {
            return [
                // {
                //     type: 'selection',
                //     width: 80,
                //     align: 'center',
                // },
                {
                    key: 'title',
                    minWidth: 200,
                    title: '房源',
                    align: 'left',
                    tree: true,
                },
                {
                    key: 'price',
                    minWidth: 150,
                    title: '单价',
                    align: 'left',
                    tooltip: true,
                },
                {
                    key: 'autoBreakMeterText',
                    minWidth: 140,
                    title: '水电欠费断电',
                    align: 'left',
                    tooltip: true,
                },
                {
                    key: 'autoBreakRentText',
                    minWidth: 140,
                    title: '房租欠费断电',
                    align: 'left',
                    tooltip: true,
                },
                {
                    key: 'waterTurnoffOnBalanceText',
                    minWidth: 140,
                    title: '水电欠费断水',
                    align: 'left',
                    tooltip: true,
                },
                {
                    key: 'waterTurnoffOnRentText',
                    minWidth: 140,
                    title: '房租欠费断水',
                    align: 'left',
                    tooltip: true,
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 100,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },
        // 有选中房间，显示批量设置
        isDisabled() {
            return this.nodeList.length === 0
        },
    },
    methods: {
        fetch() {
            this.loading = true
            this.nodeList = []
            Promise.all([smartmeterList(), this.$dict.get(['meter_type'])])
                .then((args) => {
                    var [view, dictGroup] = args
                    Object.assign(this.dict, dictGroup)
                    this.setData(view.data.list)
                })

                .finally(() => (this.loading = false))
        },
        setData(list) {
            const treeList = []
            list.forEach((v) => {
                const obj = this.foldMap.find((f) => f.id === v.id)
                v.expand = obj ? obj.expand : false
                if (v.level === 1) {
                    v.children = []
                    treeList.push(v)
                } else if (v.level === 2) {
                    const park = treeList.find((t) => t.id === v.pid)
                    if (park) {
                        v.children = []
                        park.children.push(v)
                    }
                } else if (v.level === 3) {
                    treeList.forEach((park) => {
                        const build = park.children.find((n) => n.id === v.pid)
                        if (build) {
                            v.children = []
                            build.children.push(v)
                        }
                    })
                } else if (v.level === 4) {
                    treeList.forEach((park) => {
                        park.children.forEach((build) => {
                            const floor = build.children.find(
                                (n) => n.id === v.pid
                            )
                            if (floor) {
                                v.autoBreakMeterText =
                                    v.autoBreakMeter == '1'
                                        ? `开启，低于${v.minAmount / 100}元`
                                        : '关闭'
                                v.autoBreakRentText =
                                    v.autoBreakRent == '1' ? '开启' : '关闭'
                                v.waterTurnoffOnBalanceText =
                                    v.waterTurnoffOnBalance == '1'
                                        ? `开启，低于${v.minAmount / 100}元`
                                        : '关闭'
                                v.waterTurnoffOnRentText =
                                    v.waterTurnoffOnRent == '1'
                                        ? '开启'
                                        : '关闭'
                                floor.children.push(v)
                            }
                        })
                    })
                }
            })
            this.treeList = treeList
        },

        rowClickSetting(row) {
            this.houseIds = row.id
            this.modal.showMeterForm = true
        },
        onClickSetting() {
            const houseIds = []
            this.nodeList.forEach((v) => houseIds.push(v.node.id))
            this.houseIds = houseIds.join(',')
            this.modal.showMeterForm = true
        },
        checkChange(nodes) {
            this.nodeList = nodes.filter((v) => v.level === 3)
        },
        toggleExpand(el) {
            let obj = this.foldMap.find((val) => val.id === el.data.id)
            if (obj) {
                obj.expand = el._isExpand
            } else {
                this.foldMap.push({ id: el.data.id, expand: el._isExpand })
            }
        },
    },
    created() {
        window.t = this
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
}
</script>

<style lang="scss" scoped></style>
